import type { ReactNode } from "react";

import {
	StatementContentBox,
	StatementFieldsRow,
	StatementNumberLabel,
	StatementRow,
} from "./styled/formstatements.styled";

interface FormStatementContainerProps {
	num: number;
	children: ReactNode;
}

const FormStatementContainer = ({ num, children }: FormStatementContainerProps) => (
	<StatementRow>
		<StatementNumberLabel>{num}</StatementNumberLabel>
		<StatementContentBox>
			<StatementFieldsRow>{children}</StatementFieldsRow>
		</StatementContentBox>
	</StatementRow>
);

export default FormStatementContainer;
